<ng-container *ngIf="isRenew === true; else main202009">
  <app-main202208></app-main202208>
</ng-container>
<ng-template #main202009>
  <app-main202009></app-main202009>
</ng-template>